module.exports = __webpack_public_path__ + "img/warehouses.81c79160.svg";